import { TreasuryOverview } from "@/features/treasury/treasury";

export default function TreasuryPage() {
  return <TreasuryOverview />;
}
